import { clsx, type ClassValue } from "clsx";
import { ComponentType } from "react";
import * as Icons from "@/assets/icons";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const getIcon = (
  name: string
): ComponentType<{ className?: string }> | undefined => {
  const formattedName = name.replace(/\s+/g, "").toLowerCase();
  const matchingKey = Object.keys(Icons).find(
    (key) => key.toLowerCase() === formattedName
  );
  return matchingKey
    ? (Icons[matchingKey as keyof typeof Icons] as ComponentType<{
        className?: string;
      }>)
    : undefined;
};

export const scrollToSection = (id: string, offset = 80) => {
  const element = document.getElementById(id);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};
